module.exports = __webpack_public_path__ + "img/Reliable-service-7-24.81c954f3.png";